import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import {Colors} from '@constants/colors.constants';
import {ArrowBack} from '@icons/index';
import {IconButton, Stack, Typography} from '@mui/material';
import {History, historyService} from '@store/settings/history';
import {useSnackbar} from 'notistack';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import ReactDiffViewer, {DiffMethod} from 'react-diff-viewer';
import {Outlet, useNavigate, useParams} from 'react-router-dom';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';

dayjs.extend(LocalizedFormat);

const HistoryDetails = () => {
  const navigate = useNavigate();
  const {historyId} = useParams();
  const {t} = useTranslation();
  const [history, setHistory] = useState<History>();

  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    if (historyId) {
      historyService.getHistory(historyId).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
        next: (res) => setHistory(res[0]),
      });
    }
  }, [enqueueSnackbar, historyId]);

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={3} overflow="hidden">
      <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1} ml="-9px">
        <IconButton onClick={handleClose}>
          <ArrowBack/>
        </IconButton>
        <Typography fontSize="30px" fontWeight="700">
          {history?.tableName}
        </Typography>
      </Stack>
      <Stack width="100%" flex={1} overflow="auto">
        <Stack mt="12px" p="18px" bgcolor={Colors.white}>
          <Stack spacing={3}>
            <Stack direction="row" spacing={2}>
              <Stack spacing={0.5} flex={1}>
                <Typography fontSize="16px" fontWeight="400">
                  {t('settings.histories.table.createdAt')}
                </Typography>
                <TextFieldComponent value={history?.createdAt ? dayjs(history.createdAt).format('LLLL') : ''}
                                    readOnly/>
              </Stack>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Stack flex={1} spacing={0.5}>
                <Typography fontSize="16px" fontWeight="400">
                  {t('settings.histories.table.user')}
                </Typography>
                <TextFieldComponent value={`${history?.authorLastName} ${history?.authorFirstName}` || ''} readOnly/>
              </Stack>
              <Stack flex={1} spacing={0.5}>
                <Typography fontSize="16px" fontWeight="400">
                  {t('settings.histories.table.tableName')}
                </Typography>
                <TextFieldComponent value={history?.tableName || ''} readOnly/>
              </Stack>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Stack flex={1} spacing={0.5}>
                <Typography fontSize="16px" fontWeight="400">
                  {t('settings.histories.table.type')}
                </Typography>
                <TextFieldComponent value={history?.eventType || ''} readOnly/>
              </Stack>
              <Stack flex={1} spacing={0.5}>
                <Typography fontSize="16px" fontWeight="400">
                  {t('settings.histories.table.id')}
                </Typography>
                <NumberTextFieldComponent value={history?.ressourceId} readOnly/>
              </Stack>
            </Stack>
            <Stack direction="row" spacing={2} overflow="auto">
              {history?.newValue && (
                <ReactDiffViewer
                  leftTitle={t('settings.histories.table.previousValue')}
                  rightTitle={t('settings.histories.table.newValue')}
                  compareMethod={DiffMethod.CHARS}
                  oldValue={undefined}
                  newValue={JSON.stringify(JSON.parse(history.newValue), null, 2)}
                  showDiffOnly
                  splitView={false}
                />
              )}
            </Stack>
          </Stack>
        </Stack>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default HistoryDetails;
